export const darkBlue = "#2c748b";

export const steelBlue = "#4682B4"

export const lightBlue = "#96CCD7";

export const lightYellow = "gold";

export const darkYellow = "goldenrod";

export const white = "#DFE3E6";

export const whitesmoke = "whitesmoke";
